import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
    return (
        <footer id="contact" className="bg-[#FCEBEB] text-gray-800 pt-16 pb-8">
            <div className="max-w-6xl mx-auto px-6">
                {/* Main Footer Content */}
                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
                    {/* Company Info */}
                    <div>
                        <div className="">
                            <img
                                src="/images/logo.png"
                                alt="Frelish Yogurt Logo"
                                className="w-35 h-10 object-contain"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = "https://cdn-icons-png.flaticon.com/512/1141/1141149.png";
                                }}
                            />
                        </div>
                        {/*<p className="text-gray-600 mt-6 mb-6">
                            Frelish Foods, is a fast-growing dairy brand with 2 million+ units sold in just 2 years — a favorite among young adults across Tamil Nadu and Bengaluru.
                        </p>*/}
                        <p className="text-gray-600 mt-6 mb-6">
                            FRELISH FOODS PVT. LTD. < br/>
                            15/9, Masilamani Road, <br/>Balaji Nagar, Royapettah, < br/> Chennai - 600 014. <br/>
                            P : 73580 76090 < br/>
                            E : sales@frelishfoods.com or marketing@frelishfoods.com
                        </p>

                        {/* SOCIAL LINKS - NOW OPEN IN NEW TAB */}
                        <div className="flex gap-4">
                            <a
                                href="https://www.facebook.com/people/Frelishfoods/61578253596564/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#DE0000] hover:text-[#3d6f5b] transition-colors"
                                aria-label="Facebook (opens in new tab)"
                            >
                                <Facebook size={20} />
                            </a>
                            <a
                                href="https://www.linkedin.com/company/frelish-foods/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#DE0000] hover:text-[#3d6f5b] transition-colors"
                                aria-label="LinkedIn (opens in new tab)"
                            >
                                <Linkedin size={20} />
                            </a>
                            <a
                                href="https://www.instagram.com/frelishfoods/?hl=en"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-[#DE0000] hover:text-[#3d6f5b] transition-colors"
                                aria-label="Instagram (opens in new tab)"
                            >
                                <Instagram size={20} />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-6">Quick Links</h3>
                        <ul className="space-y-3">
                            <li><a href="/#products" className="text-gray-600 hover:text-[#DE0000] transition-colors">Our Products</a></li>
                            <li><a href="/#about" className="text-gray-600 hover:text-[#DE0000] transition-colors">Our Story</a></li>
                            <li><a href="/#sustainability" className="text-gray-600 hover:text-[#DE0000] transition-colors">Sustainability</a></li>
                            <li><a href="/#contact" className="text-gray-600 hover:text-[#DE0000] transition-colors">Contact Us</a></li>
                        </ul>
                    </div>

                    {/* Support */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-6">Support</h3>
                        <ul className="space-y-3">
                            <li><a href="/#faq" className="text-gray-600 hover:text-[#DE0000] transition-colors">FAQ</a></li>
                            <li><a href="/#shipping" className="text-gray-600 hover:text-[#DE0000] transition-colors">Shipping Policy</a></li>
                            <li><a href="/#returns" className="text-gray-600 hover:text-[#DE0000] transition-colors">Returns</a></li>
                            <li><a href="/#privacy" className="text-gray-600 hover:text-[#DE0000] transition-colors">Privacy Policy</a></li>
                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-6">Stay Updated</h3>
                        <p className="text-gray-600 mb-4">Subscribe to our newsletter for updates and exclusive offers.</p>
                        <form className="flex gap-2">
                            <input
                                type="email"
                                placeholder="Your email"
                                className="flex-1 bg-white text-gray-800 px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#DE0000] border border-gray-300 shadow-sm"
                            />
                            <button
                                type="submit"
                                className="bg-[#DE0000] hover:bg-[#3d6f5b] text-white px-4 py-2 rounded-lg transition-colors shadow-sm hover:shadow"
                            >
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-emerald-200 pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center">
                        <p className="text-gray-600 text-sm">
                            © 2026 Frelish Foods. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;